export const contactsData = {
    email: 'parmarambuldak800@gmail.com',
    phone: '+91 9079660203',
    address: 'Makrana Rajasthan',

    sheetAPI: 'https://sheetdb.io/api/v1/tt5b8x0x5sbmo'
}
